// Instance of a customer from the Unleashed Application - Served through the RealiSupply Lambda
import { ShippingDetails } from "./shippingDetail.model";
import { ISupportingDocument } from "./supporting.document.model";
import { INewUser, User } from "./user.model";
import { ICustomerUser } from "./customer.user.model";
import {
  DecorationOrProduct,
  IRequiredField,
  NewDecoration,
  ProductCustomer,
} from "./ddb.model";
import { QueryResult } from "./query.filter.class";
import { ICollectionCustomer } from "./collection.model";
import { IRole } from "./role.model";

export type EmployeePurchaseMode = "credit-card" | "invoice" | "both";

export class UnleashedCustomer {
  id: number | null = null;
  name!: string;
  code!: string;
  Guid: string | null = null;
  CustomerCode: string | null = null;
  CustomerName: string | null = null;
  imageUrl: string | null = null;
  BusinessUnits!: QueryResult<Array<BusinessUnit>> | Array<BusinessUnit>;
  Addresses: Array<ShippingDetails> = [];
  Products!: QueryResult<Array<ProductCustomer>>;
  AssignedProductsOnly = false;
  HandlingFee = true;
  HandlingFeeAmount: number | null = 20;
  HandlingFeeThreshold: number = 250;
  HandlingFeeCoPay!: number;
  PurchaseOrderPattern = "";
  search: string | null = null;
  reminders!: QueryResult<Reminder>;
  RegisterEnabled: boolean = false;
  RegisterEmailPattern: string | null = null;
  RegisterUserRole: any = null;
  RegisterUserRoleId: number | null = null;
  RegisterSecret: string | null = null;

  /**
   * All futuer property names should be in normal casing so that
   * this class can ultimately be deprecated
   */
  employeePurchaseMode: EmployeePurchaseMode = "credit-card";
  supportingDocuments!: ISupportingDocument[];
  customerUsers!: ICustomerUser[];
  disableAddressEdit!: boolean;
  showProductSearchCategories!: boolean;
  showProductSearchCollections!: boolean;
  enableBulkOrder!: boolean;
  enableOrdersAllocation!: boolean;
  defaultUri!: string;
  redirectEmail!: string;
  ccEmail: string | null = null;
  discountAmount: number = 0;
  enableOrdersRequireApproval: boolean = false;
  stopCredit: boolean = false;
  allowPackOrderNames: boolean = false;
  disable2faCheck: boolean = false;
  defaultWarehouse: string | null = null;
  obsolete: boolean = false;
  collections!: ICollectionCustomer[];
  decorations!: { decoration: DecorationOrProduct; customPrice: number }[];
  automaticCollectionSelection: boolean = false;
  poLabelName: string = "Purchase Order Number";
  enableUsersRequireApproval: boolean = false;
  enableOrdersReminderApproval: boolean = false;
  requiredField!: string;
  checkoutFields: string[] = [];
  showPrice: boolean = false;
  enableStore: boolean = false;
  isShowCategoryInCollection: boolean = false;
  isGlobalRoleHide: boolean = false;
  emailMessage: string | null = null;
  canSendAllocationMail: boolean = true;
  TaxRate!: number | null;
  SalesOrderGroup!: string;
  TaxCode!: string | null;
  beforeSave = () => {
    this.search = (this.CustomerName + " " + this.CustomerCode).toLowerCase();
  };
  enableSubstituteApproval: boolean = false;
  substituteProductsRange: string = "customer_products";
  backordercc: string = "";
  isDefaultWarehouseOverrides!: boolean;
  showBackorderOptionAtCheckout!: boolean;
  // isFlatRateShippingEnabled: boolean = true;
  backorderUserId!: string | null;
  backorderUser!: INewUser | null;
}

export class UnleashedCustomerExtended extends UnleashedCustomer {
  CustomerUser!: User | null;
  CustomerUserRole!: IRole | null;
  IsDefault!: boolean | null;
}

export class UnleashedCustomerListResult {
  pagination!: UnleashedPaginationData;
  items: Array<UnleashedCustomer> = [];
}

export class UnleashedCustomerListRequest {
  Pagination!: UnleashedPaginationData;
  Items: Array<UnleashedCustomer> = [];
}
export class Reminder {
  id?: number;
  customerId!: number;
  noOfUnit!: number;
  unit!: string;
}
export class BusinessUnit {
  id?: number;
  name!: string;

  Guid!: string;
  Name!: string;
  code!: string;
  // The ID of the user who is the contact for this cost center
  // DO NOT STORE USER DETAILS HERE else we will be forever having to
  // Update them every time a user is updated
  Contact!: string;
  purchaser!: { user: { firstName: string; lastName: string } } | null;
  approver!: { user: { firstName: string; lastName: string } } | null;
  CustomerId!: string;
  ShippingDetailsId!: string;
  ShippingDetails: ShippingDetails = new ShippingDetails();
  deletedAt?: string | null;

  /**
   * 1:1 Mapping of properties until this class can be decprecated
   */
  contactId!: number | null;

  beforeSave = () => {
    this.ShippingDetails.beforeSave();
  };
}

export class DocumentClass {
  id!: number;
  userId!: number;
  customerId!: number;
  modifiedById!: number | null;
  createdById!: number | null;
  approvedById!: number | null;
  isApproved!: boolean;
  name!: string;
  path!: string;
  fileSize!: number;
  mimeType!: string;
}

export interface IUnleashedWarehouse {
  WarehouseCode: string;
  WarehouseName: string;
  IsDefault: boolean;
  StreetNo: string | null;
  AddressLine1: string | null;
  AddressLine2: string | null;
  Suburb: string | null;
  City: string | null;
  Region: string | null;
  Country: string | null;
  PostCode: string | null;
  PhoneNumber: string | null;
  FaxNumber: string | null;
  MobileNumber: string | null;
  DDINumber: string | null;
  ContactName: string | null;
  Obsolete: boolean;
  Guid: string;
  LastModifiedOn: string;
}

export class UnleashedPaginationData {
  public NumberOfItems!: number;
  public PageSize!: number;
  public PageNumber!: number;
  public NumberOfPages!: number;

  constructor(fields?: {
    NumberOfItems: number;
    PageSize: number;
    PageNumber: number;
    NumberOfPages: number;
  }) {
    if (fields) {
      Object.assign(this, fields);
    }
  }

  hasMorePages = () => {
    return this.PageNumber < this.NumberOfPages;
  };
}
